<template>
	<div>
		<el-row>
			<el-col :span="24">{{school_data.school_name}}</el-col>
		</el-row>
		<el-row>
			<el-col :span="24/school_data.campus.length" v-for="(campus,campus_index) in school_data.campus"
				:key="campus_index">
				{{campus.campus_name}}
				<el-row>
					<el-col :span="24/campus.school_level.length" v-for="(level,level_index) in campus.school_level"
						:key="level_index">
						{{level.level_name}}
						<el-row>
							<el-col :span="24/level.school_grade.length"
								v-for="(grade,grade_index) in level.school_grade" :key="grade_index">
								{{grade.grade_name}}
								<el-row>
									<el-col :span="24">
										<div v-for="(cla,cla_index) in grade.school_class" :key="cla_index" style="margin-top: 5px;">
											<el-tag closable @close="handleClose(cla.id)" @click="student_names(cla.id)">{{cla.period+'级'+grade.grade_name+cla.class_number+'班'}}</el-tag>
										</div>
									</el-col>
								</el-row>
							</el-col>
						</el-row>
					</el-col>
				</el-row>
			</el-col>
		</el-row>
		<UploadFile downloadUrl="/admin/classinfo/excel_export" uploadUrl="/admin/classinfo/insert_excel"></UploadFile>
	</div>
</template>

<script>
	import UploadFile from '../components/UploadFile.vue'
	import {
		getData
	} from "@/utils/table"
	export default {
		name: 'DtTeacher',
		components: {
			UploadFile,
		},
		data() {
			return {
				school_data: [],
				name: "",
				page_totle: 1,
				codes: [],
				select_val: [],
				test: {
					name: 'zengqingqing',
					age: '13',
					heigt: 170
				}
			}
		},
		created() {
			var key = 'name'
			console.log(this.test[key])
			getData(this, "/admin/classinfo/index", {
				page: 1
			}, data => {
				this.school_data = data
			})
		},
		methods: {
			edit() {
				if (this.select_val.length < 1) {
					this.$message({
						message: '请选择一条数据！',
						type: 'warning'
					})
				} else {
					if (this.select_val.length == 1) {
						this.edit_teacher = this.select_val[0];
						this.editVisible = true;
					} else {
						this.$message({
							message: '只能选择一条数据！',
							type: 'warning'
						})
					}
				}
			},
			post_edit() {

			},
			handleClose(id) {
				getData(this, "/admin/classinfo/delete", {
					id,
				}, data => {
					if (data.status == "success") {
						this.$message({
							message: data.message,
							type: 'success'
						})
						getData(this, "/admin/classinfo/index", {
							page: 1
						}, data => {
							this.school_data = data
						})
					} else {
						this.$message({
							message: data.message,
							type: 'warning'
						})
					}

				})
			},
			student_names(id) {
				console.log(id)
				getData(this, "/admin/classinfo/search_students", {
					id,
				}, data => {
					this.$alert(data, '学生名字', {
						confirmButtonText: '确定',
						callback: action => {
							this.$message({
								type: 'info',
								message: `action: ${ action }`
							});
						}
					})
				})
			},
			//表格选择处理，选出每条数据的编码
			handleSelectionChange(val) {
				this.select_val = val;
				let that = this;
				this.codes = [];
				val.forEach(function(item) {
					that.codes.push(item.code);
				});
			},
			//翻页处理
			currentPage(val) {
				getData(this, "/admin/classinfo/index", {
					page: val
				}, (data) => {
					this.page_totle = data[0]
					this.tableData = data[1]
					for (var i = 0; i < this.tableData.length; i++) {
						if (this.tableData[i].status == 0) {
							this.tableData[i].status_text = "正常"
						} else {
							this.tableData[i].status_text = "已毕业"
						}
					}
				})
			},
			add_grade() {
				this.service.post('/admin/classinfo/add_grade', {
					school_id: localStorage.school_id
				}).then(respon => {
					if (respon.data === 'success') {
						this.$message({
							message: '自动刷新完成！',
							type: 'success'
						})
					}
				}, err => {
					alert(err.message);
				})
			}
		}
	}
</script>

<style lang="scss">
	.el-row {
		text-align: center;
		margin-top: 20px;
	}
</style>